import calls from '@/backend/api-calls'

const state = () => ({
  installMethods: [],
  selected: [],
  allSelected: false,
  loading: false,
  pagination: {
    page: 1,
    pages: 1
  },
  filters: {
  }
})

// getters
const getters = {
  ids: state => {
    return state.installMethods.map(d => d.id);
  }
}

// actions
const actions = {
  getInstallMethods: ({commit}, parameters) => {
    commit("setLoading", true);
    return new Promise((resolve, reject) => {
      calls.installMethods.get(parameters)
        .then(resp => {
          commit("setInstallMethods", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addInstallMethod: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.installMethods.post(data)
        .then(resp => {
          commit("insertInstallMethod", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateInstallMethod: ({commit}, { methodId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installMethod.put(methodId, data)
        .then(resp => {
          commit("insertUpdatedInstallMethod", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  deleteInstallMethod: ({commit}, methodId) => {
    return new Promise((resolve, reject) => {
      calls.installMethod.delete(methodId)
        .then(resp => {
          commit("removeInstallMethod", methodId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Installation Method successfully deleted'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addImage: ({commit}, { methodId, data }) => {
    return new Promise((resolve, reject) => {
      calls.installMethod.addImage(methodId, data)
        .then(resp => {
          commit("insertUpdatedInstallMethod", resp.data);
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setInstallMethods (state, data) {
    state.installMethods = data.results;
    state.pagination = data.pagination;
  },
  insertInstallMethod (state, data) {
    state.installMethods.push(data);
  },
  insertUpdatedInstallMethod (state, data) {
    state.installMethods.forEach((installMethod, i) => {
      if (installMethod.id == data.id) {
        state.installMethods.splice(i, 1, data);
      }
    })
  },
  removeInstallMethod (state, id) {
    state.installMethods.forEach((installMethod, i) => {
      if (installMethod.id == id) {
        state.installMethods.splice(i, 1);
        let ind = state.selected.indexOf(id);
        if (ind != -1) {
          state.selected.splice(ind);
        }
      }
    })
  },
  changePage(state, page) {
    state.pagination.page = page;
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}